import {
  LoaderProps as MantineLoaderProps,
  Loader as MantineLoader,
} from '@mantine/core';

export type LoaderProps = MantineLoaderProps;

export const Loader = MantineLoader;

Loader.displayName = 'Loader';
